import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

/** What the guard needs of the component it protects. */
export interface ConfirmsLeaving {
  confirmLeave(): Observable<boolean> | boolean;
}

/**
 * Stop the user leaving the campaign wizard while it still holds edits they never saved.
 *
 * The edits live on `CampaignWizardService`, which is provided at the wizard layout — so they
 * exist exactly as long as the user is in the wizard, and leaving is what destroys them. That is
 * the right lifetime (ADR 0001 D2 keeps readiness reading persisted data, and nothing here is
 * persisted); it simply must not happen without being said out loud.
 *
 * The guard asks the component rather than the service so that the question and the dialog that
 * answers it stay together — and so a wizard with nothing outstanding returns `true` synchronously
 * and never flickers a dialog at someone who has saved everything.
 */
export const unsavedChangesGuard: CanDeactivateFn<ConfirmsLeaving> = component =>
  component?.confirmLeave?.() ?? true;
